import script from "./NoSearchResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoSearchResults.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__